import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const breadcrumbItems = [
  { label: '首页', path: '/' },
  { label: '关于我们' },
];

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '51吃瓜每日大赛',
  url: 'https://www.51chigua.com',
  description: '51吃瓜每日大赛汇集全网热门吃瓜爆料与黑料视频，实时更新网红塌房、明星翻车、企业内幕等最新大瓜，打造每日吃瓜第一站。',
  foundingDate: '2020',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'admin@51chigua.com',
    availableLanguage: ['Chinese'],
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '51吃瓜每日大赛是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '51吃瓜每日大赛是一个娱乐八卦资讯聚合平台，汇集全网热门吃瓜爆料与黑料视频。覆盖明星翻车、网红塌房、企业内幕等最新大瓜，每日实时更新，打造吃瓜第一站。',
      },
    },
    {
      '@type': 'Question',
      name: '51吃瓜每日大赛的内容来源是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们的内容来源于网友投稿、社交媒体公开信息、新闻报道等多渠道。所有内容均经过编辑团队核实整理，确保信息的真实性和时效性。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向51吃瓜每日大赛投稿？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过网站顶部的"投稿入口"按钮提交您的爆料内容，也可以发送邮件至admin@51chigua.com。我们会对所有投稿进行审核，优质内容将获得优先展示。',
      },
    },
    {
      '@type': 'Question',
      name: '51吃瓜每日大赛的内容更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们保持24小时不间断更新，专业编辑团队全天候监控热点事件。一旦有重大爆料或事件进展，您将在第一时间在我们的平台上看到。',
      },
    },
  ],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '关于我们 - 51吃瓜每日大赛',
  description: '了解51吃瓜每日大赛的品牌故事、核心优势与联系方式。专注吃瓜爆料十年，全网覆盖实时更新，致力打造最专业的娱乐八卦资讯平台。',
  url: 'https://www.51chigua.com/about',
};

export default function AboutPage() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <Navbar />

      <main>
        <section className="pt-24 pb-14 md:pt-32 md:pb-20 bg-background-100">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>
            <span className="inline-block px-3 py-1 text-xs font-label font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4">
              关于51吃瓜
            </span>
            <div className="relative">
              <h1 className="text-2xl md:text-5xl font-heading font-black text-foreground-900 leading-tight">
                专注吃瓜爆料
                <span className="inline-block w-20 md:w-28 h-12 md:h-16 rounded-xl overflow-hidden mx-3 align-middle">
                  <img
                    src="https://readdy.ai/api/search-image?query=Editorial%20team%20working%20in%20modern%20office%2C%20collaborative%20atmosphere%2C%20warm%20lighting%2C%20professional%20newsroom%2C%20diverse%20team%2C%20creative%20workspace&width=200&height=120&seq=about-team-1&orientation=landscape"
                    alt="51吃瓜团队"
                    className="w-full h-full object-cover"
                  />
                </span>
              </h1>
              <p className="text-2xl md:text-5xl font-heading font-black text-foreground-900 leading-tight mt-1">
                十年行业深耕
                <span className="inline-block w-20 md:w-28 h-12 md:h-16 rounded-xl overflow-hidden mx-3 align-middle">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20computers%2C%20warm%20ambient%20lighting%2C%20professional%20environment%2C%20content%20creation%20studio&width=200&height=120&seq=about-office-1&orientation=landscape"
                    alt="51吃瓜办公环境"
                    className="w-full h-full object-cover"
                  />
                </span>
              </p>
              <p className="text-2xl md:text-5xl font-heading font-black text-foreground-900 leading-tight mt-1">
                让真相无处隐藏
              </p>
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mt-6">
              51吃瓜每日大赛成立于2020年，是国内领先的娱乐八卦资讯聚合平台。我们拥有一支经验丰富的编辑团队，
              覆盖明星、网红、商业等多个领域的独家爆料内容，致力于为广大瓜友提供最快、最全、最真实的吃瓜体验。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a href="#brand-story" className="inline-flex items-center justify-center px-6 py-3 bg-secondary-500 hover:bg-secondary-600 text-white font-label text-sm rounded-full transition-colors whitespace-nowrap">
                品牌故事
              </a>
              <a href="#contact" className="inline-flex items-center justify-center px-6 py-3 border-2 border-secondary-500 text-secondary-600 hover:bg-secondary-50 font-label text-sm rounded-full transition-colors whitespace-nowrap">
                商务合作
              </a>
            </div>
          </div>
        </section>

        <section id="brand-story" className="py-14 md:py-20 bg-background-50">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-8">品牌故事</h2>
            <div className="flex flex-col md:flex-row gap-10">
              <div className="md:w-2/3">
                <p className="text-foreground-700 leading-relaxed mb-4">
                  51吃瓜每日大赛诞生于信息爆炸的时代。在娱乐八卦信息满天飞的网络世界里，
                  我们意识到用户需要的不仅仅是"吃瓜"，更需要的是真实、全面、及时的爆料信息。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  成立六年来，我们始终秉持"真实第一、速度至上"的原则，建立了覆盖全网的信息采集网络。
                  从明星翻车到网红塌房，从企业内幕到社会热点，我们坚持为用户呈现事件的完整面貌。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  如今，51吃瓜每日大赛已成为国内最具影响力的娱乐八卦资讯平台之一，日均活跃用户超过10万人次。
                  我们不仅是一个资讯平台，更是一个让瓜友们自由交流、分享观点的社区。
                </p>
              </div>
              <div className="md:w-1/3">
                <div className="bg-background-100 rounded-2xl p-6">
                  <div className="text-3xl font-heading font-bold text-primary-500 mb-2">10w+</div>
                  <p className="text-sm text-foreground-600 mb-6">日均活跃用户</p>
                  <div className="text-3xl font-heading font-bold text-primary-500 mb-2">24/7</div>
                  <p className="text-sm text-foreground-600 mb-6">全天候内容更新</p>
                  <div className="text-3xl font-heading font-bold text-primary-500 mb-2">6年</div>
                  <p className="text-sm text-foreground-600">行业深耕经验</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <span className="text-xs font-label text-foreground-500 uppercase tracking-wider">我们的优势</span>
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-900 mt-2 leading-tight">
              为什么选择
            </h2>
            <p className="text-2xl md:text-4xl font-heading font-black text-foreground-900 leading-tight mb-10">
              51吃瓜每日大赛？
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5 text-foreground-800">
                  <i className="ri-flashlight-line text-3xl"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">实时更新</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  专业编辑团队24小时不间断追踪热点事件。一旦有重大爆料或事件进展，第一时间呈现在您面前，确保您不会错过每一个大瓜。
                </p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5 text-foreground-800">
                  <i className="ri-global-line text-3xl"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">全网覆盖</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  建立覆盖微博、抖音、小红书、B站等全平台的信息采集网络。从明星八卦到网红翻车，从商业内幕到社会热点，涵盖所有吃瓜领域。
                </p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <div className="w-12 h-12 flex items-center justify-center mb-5 text-foreground-800">
                  <i className="ri-shield-check-line text-3xl"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">真实爆料</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  严格的内容审核机制，所有爆料信息均经过多渠道交叉验证。我们坚持"有据可查、有源可溯"的原则，拒绝虚假信息和恶意造谣。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-900 mb-3">
              有料要爆？立即联系
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-10 font-label">
              如果您有独家爆料线索，欢迎通过以下方式联系我们
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
              <div className="bg-background-100 rounded-2xl p-6">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-secondary-500">
                  <i className="ri-mail-line text-3xl"></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">投稿邮箱</h3>
                <p className="text-sm text-foreground-600">admin@51chigua.com</p>
              </div>
              <div className="bg-background-100 rounded-2xl p-6">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-secondary-500">
                  <i className="ri-hand-heart-line text-3xl"></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">商务合作</h3>
                <p className="text-sm text-foreground-600">hezuo@51chigua.com</p>
              </div>
              <div className="bg-background-100 rounded-2xl p-6">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 text-secondary-500">
                  <i className="ri-customer-service-2-line text-3xl"></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">用户反馈</h3>
                <p className="text-sm text-foreground-600">feedback@51chigua.com</p>
              </div>
            </div>

            <div className="flex items-center justify-center gap-4 md:gap-8 flex-wrap">
              {[
                { src: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20news%20camera%20and%20microphone%2C%20media%20cutout%20style%2C%20clean%20white%20background%2C%20minimal%20design&width=200&height=120&seq=about-bottom-1&orientation=landscape', alt: '合作媒体' },
                { src: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20two%20people%20shaking%20hands%2C%20business%20partnership%20cutout%20style%2C%20clean%20white%20background%2C%20minimal%20design&width=200&height=120&seq=about-bottom-2&orientation=landscape', alt: '商务合作' },
                { src: 'https://readdy.ai/api/search-image?query=Silhouette%20of%20smartphone%20with%20notification%2C%20social%20media%20cutout%20style%2C%20clean%20white%20background%2C%20minimal%20design&width=200&height=120&seq=about-bottom-3&orientation=landscape', alt: '社交媒体' },
              ].map((img, i) => (
                <div key={i} className="w-28 md:w-36 h-20 md:h-24 rounded-xl overflow-hidden bg-background-100 flex-shrink-0">
                  <img src={img.src} alt={img.alt} className="w-full h-full object-cover" />
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}